<template>
  <div>
    <el-drawer title="确认完工" :before-close="handleClose" :visible.sync="drawer" direction="rtl" custom-class="demo-drawer"
               ref="drawer">
      <div class="demo-drawer__content">

        <div style="font-size: 12px;color: rgba(86, 86, 86, 0.96); margin-top:30px">
          <span style="text-align: right;    width: 77px;display: block; margin-bottom: 10px;">确认结果：</span>
          <el-radio-group v-model="radio" @change="radioHandleChange" style="margin-left: 50px;
    margin-bottom: 10px;">
            <el-radio :label="1">确认完工</el-radio>
            <el-radio :label="2">驳回完工</el-radio>
          </el-radio-group>
        </div>
        <el-form :model="cancalReason">
          <el-form-item label="驳回意见" :label-width="formLabelWidth">
            <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 8 }" v-model="cancalReason" :disabled="inCancalReason"
                      autocomplete="off"></el-input>
          </el-form-item>
        </el-form>

        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="comfirmOrder" :loading="loading">
            {{ loading ? '提交中 ...' : '确 定' }}
          </el-button>
        </div>
      </div>
    </el-drawer>

  </div>
</template>
<script>
import store from "@/store";
import api from "@/api/projectApi";
import duDialog from "@/views/dialogCommon/adminDialogByRole.vue";
import {echoFileFormat, uploadFileFormat} from "@/util/uploadFormat";
import orderPop from "@/views/dialogCommon/radioOrderDialog.vue";
import {dictType, loadDictData} from "@/config/dictType";
import request from "@/router/axios";
import pager from "@/components/pager/index.vue";
import {indexPageMixins} from "@/mixins/tabChang";

export default {
  inject: ['reload'],
  name: 'edit',
  props: ['multi', 'param'],
  mixins: [indexPageMixins],

  created() {
    this.dataId = this.param ? this.param.orderId ? this.param.orderId : '' : ''
    this.showInRemark = this.param ? this.param.showInRemark ? this.param.showInRemark : '' : ''
    this.orderRemarkData.id = this.param ? this.param.orderId ? this.param.orderId : '' : ''
  },
  mounted() {
    this.getData()
    this.loadDictData();
  },
  components: {pager},
  computed: {
    api() {
      return api
    },
    idsLength() {
      this.formData.numuber =  this.ids.length;
      this.formData.ids = this.ids;
    },

    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      }
    },
  },
  watch: {

  },
  data() {
    return {
      radio: 1,
      inCancalReason:true,
      type:null,
      showSitePop:false,
      formLabelWidth: '80px',
      bookReasnList:[],
      BookReasn:false,
      disableForReson:false,
      dataId:null,
      cancalReason:'',
      formData: {
        changeBookReasn:null,
        bookTimes:0,
        remark: null,
        firstBookDate:"",
        bookDate:"",
        bookDatePeriod:"",
        reBookDate:"",
        reBookDatePeriod:""
      },
      showOrderPop: false,

      drawer: true,


    }
  },
  methods: {
    getData() {
      request({
        url: api.soOrder.getDataUrl,
        method: 'post',
        data: {
          id: this.dataId
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
      })
    },

    radioHandleChange(val) {
      if (val == 2) {
        this.radio = 2
        this.inCancalReason=false;
      } else {
        this.radio = 1;
        this.inCancalReason=true;
      }
    },

    comfirmOrder(row){
      if(this.radio==2&&(this.cancalReason==''||this.cancalReason==null)){
        this.$message.error("驳回完工请填写驳回意见")
        return
      }
      this.$baseConfirm('是否确认完工？').then(() => {
        this.$http({
          url: api.soOrder.comfirmOrder,
          method: 'post',
          data: {
            id:this.dataId,
            comfirmType:this.radio,
            remark:this.cancalReason
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.$message({
            type: response.data.type,
            message: response.data.content
          });
          // this.reload()// 需要刷新页面
        })
      });
    },

    cancelForm() {
      this.loading = false;
      this.drawer = false;
      clearTimeout(this.timer);
    },
    handleClose() {

      this.drawer = false;
      this.$emit('closeD', false)
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer .el-drawer__body {
  padding: 0 16px;
  background-color: #fff;
  position: relative;
}

::v-deep .el-drawer .el-drawer__header {
  background-color: #fff;
}

::v-deep .el-drawer__container {
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background: aliceblue;
  background-color: rgb(38 38 38 / 70%);
}

#containt .table-detail {
  border-collapse: collapse;
  font-size: 12px;
  border: 1px solid #ededed;
}

.btn {
  text-align: center;
}

::v-deep .el-input-number [role=button] {
  line-height: 26px;
  height: 26px;
  margin-top: 40px;
}
.el-input-number--medium {
  width: 200px;
  display: block;
  line-height: 34px;
}
.title1{
  display: inline-block;
  width: 120px;
  color: #72767b;
  font-size: 13px;
  text-align: end;
  margin: 5px 10px;
}
</style>
